import { A } from '@solidjs/router'
import { Component, createMemo } from 'solid-js'
import getSessionUserId from '../rx/shared/session/getSessionUserId'

const IndexPage: Component = () => {

  const gamesPath = createMemo(() => {
    const authId = getSessionUserId()
    if (authId) {
      return `/games?player_profile_id=${authId}`
    }
    return "/games"
  })

  return (
    <div class="pagec w-24-rem" >
      <h2>Simple Tactics</h2>
      <h2>
        <A href={"/lobby/create"}>New Skirmish Game</A>
      </h2>
      <h2>
        <A href={gamesPath()}>Games</A>
      </h2>
      <h2>
        <A href={"/maps"}>Maps</A>
      </h2>
      <h2>
        <A href={"/codex"}>Codex</A>
      </h2>
    </div>
  )
}

export default IndexPage
